import SettingsIcon from '@mui/icons-material/Settings';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../redux/ReduxHooks';
import { projectSlice } from '../../../redux/ProjectSlice';
import { ApplicationActions } from '../../../utils/constants';

const SettingsButton = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const openDrawer = useAppSelector((state) => state.project.openDrawer);

  const handleClick = () => {
    const settingsDrawerAction = openDrawer === ApplicationActions.Drawer.SETTINGS_DRAWER ? null : ApplicationActions.Drawer.SETTINGS_DRAWER;
    dispatch(projectSlice.actions.onOpenDrawer(settingsDrawerAction));
  };

  return (
    <Tooltip title={t('button.settings', 'Settings')}>
      <IconButton
        onClick={handleClick}
        sx={(theme) => ({
          color: theme.vars?.palette?.primary?.main,
        })}
        aria-label={t('aria-label.settings', 'settings')}
      >
        <SettingsIcon />
      </IconButton>
    </Tooltip>
  );
};

export default SettingsButton;
